import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
} from "react-icons/fa";
import "./ContactUs.css";

const ContactUs = () => {
  const contactData = {
    address:
      "2nd -FR, FL-C-3, Holding No-53, Ramkrishna Garh Road, Manickpur, LP-110/31/10/1, Kolkata, West Bengal-700079",
    mobile: "01169269041",
    mobile2: "03369029507",
    email: "manavadhikarforumindia@gmail.com",
  };



  return (
    <>
      <Helmet>
        <title>National Governing Body Contact Details</title>
        <meta
          name="description"
          content="Contact information for the National Governing Body, including address, mobile number, and email. Mobile responsive design with React and React Bootstrap."
        />
        <meta
          name="keywords"
          content="Manav Adhikar Forum, National Governing Body, contact, address, mobile, email, WhatsApp, React, React Bootstrap, UI, responsive, Kolkata, West Bengal"
        />
        <link rel="canonical" href="https://manavadhikarforum.in/Contact-Us" />
      </Helmet>

      <div className="app-container">
        <Container className="my-5">
          <div className="d-flex flex-column mb-4 text-center align-items-center">
            <h1 className="text-center page-title1">
              National Governing Body
              <div
                className="rounded-pill mt-2 bg-warning"
                style={{
                  height: "5px",
                  width: "15%",
                }}
              ></div>
            </h1>
          </div>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <Card className="contact-card shadow-lg p-3">
                <Card.Body>
                  <Card.Title className="text-center mb-4 card-title-icon">
                    <FaPhone className="me-2" /> Contact Information
                  </Card.Title>
                  <div className="contact-info">
                    <div className="d-flex align-items-center mb-3">
                      <FaMapMarkerAlt className="icon-large text-primary me-3" />
                      <div>
                        <h6 className="mb-0">Address</h6>
                        <p className="mb-0">{contactData.address}</p>
                      </div>
                    </div>
                    <a
                      href={`tel:${contactData.mobile2}`}
                      className="contact-link"
                    >
                      <div className="d-flex align-items-center mb-3">
                        <FaPhone className="icon-large text-success me-3" />
                        <div>
                          <h6 className="mb-0">Phone No</h6>
                          <p className="mb-0">{contactData.mobile2}</p>
                        </div>
                      </div>
                    </a>
                    {/* <a
                      href={`tel:${contactData.mobile}`}
                      className="contact-link"
                    >
                      <div className="d-flex align-items-center mb-3">
                        <FaPhone className="icon-large text-success me-3" />
                        <div>
                          <h6 className="mb-0">Phone No</h6>
                          <p className="mb-0">{contactData.mobile}</p>
                        </div>
                      </div>
                    </a> */}
                    {/* <a
                      href={`https://wa.me/${contactData.mobile}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-link"
                    >
                      <div className="d-flex align-items-center mb-3">
                        <FaPhone className="icon-large text-success me-3" />
                        <div>
                          <h6 className="mb-0">WhatsApp No</h6>
                          <p className="mb-0">{contactData.mobile}</p>
                        </div>
                      </div>
                    </a> */}
                    <a
                      href={`https://wa.me/+919064634965`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-link"
                    >
                      <div className="d-flex align-items-center mb-3">
                        <FaWhatsapp className="icon-large text-success me-3" />
                        <div>
                          <h6 className="mb-0">WhatsApp No</h6>
                          <p className="mb-0">+91 90646 34965</p>
                        </div>
                      </div>
                    </a>

                    <a
                      href={`mailto:${contactData.email}`}
                      className="contact-link"
                    >
                      <div className="d-flex align-items-center mb-3">
                        <FaEnvelope className="icon-large text-danger me-3" />
                        <div>
                          <h6 className="mb-0">Email</h6>
                          <p className="mb-0">{contactData.email}</p>
                        </div>
                      </div>
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ContactUs;
